import './index.css.proxy.js';
/* src/routes/index.svelte generated by Svelte v3.31.0 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_element,
	claim_space,
	claim_text,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	space,
	text
} from "../../web_modules/svelte/internal.js";

function create_fragment(ctx) {
	let div3;
	let div0;
	let h2;
	let t0;
	let t1;
	let h3;
	let t2;
	let t3;
	let div2;
	let figure;
	let div1;
	let img;
	let img_src_value;
	let t4;
	let figcaption;
	let t5;
	let t6;
	let nav;
	let a0;
	let t7;
	let t8;
	let a1;
	let t9;
	let t10;
	let a2;
	let t11;
	let t12;
	let hr0;
	let t13;
	let p0;
	let t14;
	let t15;
	let p1;
	let t16;
	let t17;
	let hr1;
	let t18;
	let p2;
	let t19;
	let t20;
	let p3;
	let t21;
	let t22;
	let p4;
	let t23;
	let t24;
	let p5;
	let t25;
	let t26;
	let p6;
	let t27;
	let t28;
	let br;

	return {
		c() {
			div3 = element("div");
			div0 = element("div");
			h2 = element("h2");
			t0 = text("Andrew Ewing");
			t1 = space();
			h3 = element("h3");
			t2 = text("Senior Software Engineer");
			t3 = space();
			div2 = element("div");
			figure = element("figure");
			div1 = element("div");
			img = element("img");
			t4 = space();
			figcaption = element("figcaption");
			t5 = text("My daughter and I flying a drone at sunset");
			t6 = space();
			nav = element("nav");
			a0 = element("a");
			t7 = text("GitHub");
			t8 = space();
			a1 = element("a");
			t9 = text("Twitter");
			t10 = space();
			a2 = element("a");
			t11 = text("LinkedIn");
			t12 = space();
			hr0 = element("hr");
			t13 = space();
			p0 = element("p");
			t14 = text("I'm a senior software engineer and passionate problem solver living in\n  Phoenix, AZ.");
			t15 = space();
			p1 = element("p");
			t16 = text("I enjoy hanging out at home with my family, playing video games, reading, and\n  making things (usually with JavaScript).");
			t17 = space();
			hr1 = element("hr");
			t18 = space();
			p2 = element("p");
			t19 = text("Right now, my favorite web stack consists of Svelte, Typescript, PostCSS, and\n  Slonik.");
			t20 = space();
			p3 = element("p");
			t21 = text("For over a decade I have been solving all sorts of problems for businesses of\n  all shapes and sizes using web technologies.");
			t22 = space();
			p4 = element("p");
			t23 = text("I have extensive professional experience with JavaScript, CSS, HTML, SQL\n  (various flavors), PHP (4-8 and Hack), Unix & GNU tools, and more.");
			t24 = space();
			p5 = element("p");
			t25 = text("My curiosity has lead me to develop various side projects in Go, Python, Rust,\n  C++, and Lua (to name a few).");
			t26 = space();
			p6 = element("p");
			t27 = text("I enjoy learning, and take pride in my ability to quickly adapt to any\n  language or toolset.");
			t28 = space();
			br = element("br");
			this.h();
		},
		l(nodes) {
			div3 = claim_element(nodes, "DIV", { class: true });
			var div3_nodes = children(div3);
			div0 = claim_element(div3_nodes, "DIV", {});
			var div0_nodes = children(div0);
			h2 = claim_element(div0_nodes, "H2", { class: true });
			var h2_nodes = children(h2);
			t0 = claim_text(h2_nodes, "Andrew Ewing");
			h2_nodes.forEach(detach);
			t1 = claim_space(div0_nodes);
			h3 = claim_element(div0_nodes, "H3", {});
			var h3_nodes = children(h3);
			t2 = claim_text(h3_nodes, "Senior Software Engineer");
			h3_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			t3 = claim_space(div3_nodes);
			div2 = claim_element(div3_nodes, "DIV", {});
			var div2_nodes = children(div2);
			figure = claim_element(div2_nodes, "FIGURE", { class: true });
			var figure_nodes = children(figure);
			div1 = claim_element(figure_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);

			img = claim_element(div1_nodes, "IMG", {
				height: true,
				src: true,
				alt: true,
				class: true
			});

			div1_nodes.forEach(detach);
			t4 = claim_space(figure_nodes);
			figcaption = claim_element(figure_nodes, "FIGCAPTION", { class: true });
			var figcaption_nodes = children(figcaption);
			t5 = claim_text(figcaption_nodes, "My daughter and I flying a drone at sunset");
			figcaption_nodes.forEach(detach);
			figure_nodes.forEach(detach);
			div2_nodes.forEach(detach);
			div3_nodes.forEach(detach);
			t6 = claim_space(nodes);
			nav = claim_element(nodes, "NAV", { class: true });
			var nav_nodes = children(nav);
			a0 = claim_element(nav_nodes, "A", { href: true, class: true });
			var a0_nodes = children(a0);
			t7 = claim_text(a0_nodes, "GitHub");
			a0_nodes.forEach(detach);
			t8 = claim_space(nav_nodes);
			a1 = claim_element(nav_nodes, "A", { href: true, class: true });
			var a1_nodes = children(a1);
			t9 = claim_text(a1_nodes, "Twitter");
			a1_nodes.forEach(detach);
			t10 = claim_space(nav_nodes);
			a2 = claim_element(nav_nodes, "A", { href: true, class: true });
			var a2_nodes = children(a2);
			t11 = claim_text(a2_nodes, "LinkedIn");
			a2_nodes.forEach(detach);
			nav_nodes.forEach(detach);
			t12 = claim_space(nodes);
			hr0 = claim_element(nodes, "HR", {});
			t13 = claim_space(nodes);
			p0 = claim_element(nodes, "P", { class: true });
			var p0_nodes = children(p0);
			t14 = claim_text(p0_nodes, "I'm a senior software engineer and passionate problem solver living in\n  Phoenix, AZ.");
			p0_nodes.forEach(detach);
			t15 = claim_space(nodes);
			p1 = claim_element(nodes, "P", { class: true });
			var p1_nodes = children(p1);
			t16 = claim_text(p1_nodes, "I enjoy hanging out at home with my family, playing video games, reading, and\n  making things (usually with JavaScript).");
			p1_nodes.forEach(detach);
			t17 = claim_space(nodes);
			hr1 = claim_element(nodes, "HR", {});
			t18 = claim_space(nodes);
			p2 = claim_element(nodes, "P", { class: true });
			var p2_nodes = children(p2);
			t19 = claim_text(p2_nodes, "Right now, my favorite web stack consists of Svelte, Typescript, PostCSS, and\n  Slonik.");
			p2_nodes.forEach(detach);
			t20 = claim_space(nodes);
			p3 = claim_element(nodes, "P", { class: true });
			var p3_nodes = children(p3);
			t21 = claim_text(p3_nodes, "For over a decade I have been solving all sorts of problems for businesses of\n  all shapes and sizes using web technologies.");
			p3_nodes.forEach(detach);
			t22 = claim_space(nodes);
			p4 = claim_element(nodes, "P", { class: true });
			var p4_nodes = children(p4);
			t23 = claim_text(p4_nodes, "I have extensive professional experience with JavaScript, CSS, HTML, SQL\n  (various flavors), PHP (4-8 and Hack), Unix & GNU tools, and more.");
			p4_nodes.forEach(detach);
			t24 = claim_space(nodes);
			p5 = claim_element(nodes, "P", { class: true });
			var p5_nodes = children(p5);
			t25 = claim_text(p5_nodes, "My curiosity has lead me to develop various side projects in Go, Python, Rust,\n  C++, and Lua (to name a few).");
			p5_nodes.forEach(detach);
			t26 = claim_space(nodes);
			p6 = claim_element(nodes, "P", { class: true });
			var p6_nodes = children(p6);
			t27 = claim_text(p6_nodes, "I enjoy learning, and take pride in my ability to quickly adapt to any\n  language or toolset.");
			p6_nodes.forEach(detach);
			t28 = claim_space(nodes);
			br = claim_element(nodes, "BR", {});
			this.h();
		},
		h() {
			attr(h2, "class", "svelte-1lzmghw");
			attr(img, "height", "256");
			if (img.src !== (img_src_value = "https://avatars2.githubusercontent.com/u/5033161?s=460&u=c2cc0d1e3f44c974b3ea2cfc261446e17c200286&v=4")) attr(img, "src", img_src_value);
			attr(img, "alt", "Not me");
			attr(img, "class", "svelte-1lzmghw");
			attr(div1, "class", "circle");
			attr(figcaption, "class", "svelte-1lzmghw");
			attr(figure, "class", "svelte-1lzmghw");
			attr(div3, "class", "heading svelte-1lzmghw");
			attr(a0, "href", "https://www.github.com/aewing");
			attr(a0, "class", "svelte-1lzmghw");
			attr(a1, "href", "https://www.twitter.com/weveloper");
			attr(a1, "class", "svelte-1lzmghw");
			attr(a2, "href", "https://www.linkedin.com/in/apewing");
			attr(a2, "class", "svelte-1lzmghw");
			attr(nav, "class", "svelte-1lzmghw");
			attr(p0, "class", "svelte-1lzmghw");
			attr(p1, "class", "svelte-1lzmghw");
			attr(p2, "class", "svelte-1lzmghw");
			attr(p3, "class", "svelte-1lzmghw");
			attr(p4, "class", "svelte-1lzmghw");
			attr(p5, "class", "svelte-1lzmghw");
			attr(p6, "class", "svelte-1lzmghw");
		},
		m(target, anchor) {
			insert(target, div3, anchor);
			append(div3, div0);
			append(div0, h2);
			append(h2, t0);
			append(div0, t1);
			append(div0, h3);
			append(h3, t2);
			append(div3, t3);
			append(div3, div2);
			append(div2, figure);
			append(figure, div1);
			append(div1, img);
			append(figure, t4);
			append(figure, figcaption);
			append(figcaption, t5);
			insert(target, t6, anchor);
			insert(target, nav, anchor);
			append(nav, a0);
			append(a0, t7);
			append(nav, t8);
			append(nav, a1);
			append(a1, t9);
			append(nav, t10);
			append(nav, a2);
			append(a2, t11);
			insert(target, t12, anchor);
			insert(target, hr0, anchor);
			insert(target, t13, anchor);
			insert(target, p0, anchor);
			append(p0, t14);
			insert(target, t15, anchor);
			insert(target, p1, anchor);
			append(p1, t16);
			insert(target, t17, anchor);
			insert(target, hr1, anchor);
			insert(target, t18, anchor);
			insert(target, p2, anchor);
			append(p2, t19);
			insert(target, t20, anchor);
			insert(target, p3, anchor);
			append(p3, t21);
			insert(target, t22, anchor);
			insert(target, p4, anchor);
			append(p4, t23);
			insert(target, t24, anchor);
			insert(target, p5, anchor);
			append(p5, t25);
			insert(target, t26, anchor);
			insert(target, p6, anchor);
			append(p6, t27);
			insert(target, t28, anchor);
			insert(target, br, anchor);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div3);
			if (detaching) detach(t6);
			if (detaching) detach(nav);
			if (detaching) detach(t12);
			if (detaching) detach(hr0);
			if (detaching) detach(t13);
			if (detaching) detach(p0);
			if (detaching) detach(t15);
			if (detaching) detach(p1);
			if (detaching) detach(t17);
			if (detaching) detach(hr1);
			if (detaching) detach(t18);
			if (detaching) detach(p2);
			if (detaching) detach(t20);
			if (detaching) detach(p3);
			if (detaching) detach(t22);
			if (detaching) detach(p4);
			if (detaching) detach(t24);
			if (detaching) detach(p5);
			if (detaching) detach(t26);
			if (detaching) detach(p6);
			if (detaching) detach(t28);
			if (detaching) detach(br);
		}
	};
}

class Routes extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default Routes;
//# sourceMappingURL=index.js.map
